var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isJP)?_c('nav-bar-jp',{attrs:{"app":_vm.app,"dark":_vm.dark}}):_c('nav-bar-en',{attrs:{"app":_vm.app,"dark":_vm.dark}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }